import { render } from "./NewAsideDayItem.vue?vue&type=template&id=4d61a55a&scoped=true"
import script from "./NewAsideDayItem.vue?vue&type=script&lang=js"
export * from "./NewAsideDayItem.vue?vue&type=script&lang=js"

import "./NewAsideDayItem.vue?vue&type=style&index=0&id=4d61a55a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d61a55a"]])

export default __exports__